import React, { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Row } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { Table } from "@mui/material";

export const ShowPromoCodeUsersModal = (Props) => {
    let handleClose = (e) => {
        console.log(Props)
        //e.stopPropagation();
        Props.callBack()
        //history.push("privatePromoCodeList")
    };

    const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue } = useForm({
        defaultValues: {}
    });
    useEffect(() => {
        (async () => {
            try {


            } catch (error) {
                console.log("error :>> ", error);
            } finally {
            }
        })();

        return () => { };
    }, []);
    const onSubmit =
        async (data) => {
            try {


            } catch (error) {
                console.log("error=", error);
            }
        }

    return (
        <div>
            <Modal centered size='md' show={true} onHide={handleClose}>
                <form id="form" onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Header closeButton>
                        <Modal.Title>لیست  گردشگران</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <Col xs='12' sm='7' lg='12'>
                            <Table striped responsive hover>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>نام و نام خانوادگی</th>
                                        <th>تلفن</th>
                                        <th>تاریخ ورود</th>
                                        <th>تاریخ خروچ </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Props?.userList.map((item, index) => (
                                        <tr>
                                            <td>{++index}</td>
                                            <td>{item.userFirstname + " " + item.userLastName} </td>
                                            <td>{item.userPhoneNumber}</td>
                                            <td>{item.userCheckInDate}</td>
                                            <td>{item.userCheckOutDate}</td>
                                        </tr>

                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Modal.Body>
                    <Modal.Footer>

                        <Button variant="danger" onClick={handleClose}>
                            <CloseIcon />  بستن
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
}
